import React from "react";
import { motion } from "framer-motion";
import { hideAnimation, coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail12 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>為何選擇2026網頁全端攻略?</span>
        </h2>
        <p>
          超過80小時的重量級課程，包辦網頁前端到後端的必備知識，手把手帶你從頭開始學習寫程式。課程內容包含基本語法、物件導向的程式架構、解決問題的邏輯思路、遇到問題狀況的處理、Debug技巧，建立扎實的程式開發必備知識。網頁開發分為前端與後端部分。網頁全端開發課程前半段著重HMTL,
          CSS,
          JavaScript三大網頁開發基石，透過實作四個專案、兩個遊戲來鞏固所學基礎。後半部分著重於後端開發工具，包含業界常見的MongoDB,
          Node.js等後端程式設計工具。課程最後會統整前端React框架與後端API連結系統，製作出網頁開發中非常熱門的MERN專案系統！
        </p>
        <p>
          本課程講解各種現代開發工具以及應用原則，讓你不論身在何處都可以隨時隨地的學習最新知識。詳細的解說，讓你從初學者到建站大師!
          所有project皆提供原始碼與教學，讓你輕鬆動手寫程式!
          不用花大錢，即可由簡入深學習到許多開發技巧和debug觀念!
        </p>
      </motion.div>
    </div>
  );
};

export default CoursesDetail12;
